<form
  onSubmit="return false;"
  class="mb-custom"
  [formGroup]="form"
  data-automation-id="subscribe-form"
  (keyup.enter)="getInput()"
>
  <div *ngIf="!submitSuccess; else successBlock" class="input-group">
    <digital-platform-input
      data-automation-id="emailOptInput"
      [control]="form.controls['email']"
      formControlName="email"
      bg="dark"
      [errorMessage]="errorMessage"
      fontSize="14px"
      style="flex-grow: 1"
      placeholder="Enter email address"
    ></digital-platform-input>

    <ng-container *ngIf="subscriptionInProgress$ | async; else submitButton">
      <digital-platform-inline-spinner></digital-platform-inline-spinner>
    </ng-container>
    <ng-template #submitButton>
      <digital-platform-cta-button
        (click)="submitEmail()"
        [ngClass]=""
        [ctaSize]="defaultButtonSize"
        [ctaStyle]="defaultButtonStyle"
        [isButtonDisabled]="(form.valid$ | async) === false"
        data-automation-id="submitButton"
        >Submit
      </digital-platform-cta-button>
    </ng-template>
  </div>

  <ng-template #successBlock>
    <div class="opt-in-preferences" data-automation-id="validText">
      <ng-container *ngIf="responseType === responseTypes.USER_NEW">
        <h3 class="text-white">Thank you!</h3>
        <div>You have successfully signed up for Republic Services emails.</div>
      </ng-container>

      <ng-container *ngIf="responseType === responseTypes.USER_UPDATED">
        <h3 class="text-white">Thank you!</h3>
        <div>Your communication preferences have been updated.</div>
      </ng-container>
    </div>
  </ng-template>
</form>
